class VideoInline {
  constructor() {
    this.$el = $('.js-open-video-inline');
    this.classes = {
      jsOpenVideoInline: '.js-open-video-inline',
      videoContainer: '.video-container',
      appended: 'appended',
    };
  }

  init() {
    this.playInlineVideo();
  }

  playInlineVideo() {
    this.$el.on('click', (event) => {
      const $target = $(event.currentTarget);
      event.preventDefault();

      const videoUrl = $target.data('video-url');
      if (!videoUrl) { return; }

      let iframe;

      iframe = $('<iframe/>');
      if (videoUrl.includes('youtube.com') || videoUrl.includes('youtu.be')) {
        const replaceUrl = this.convertToEmbed(videoUrl);
        iframe.attr('src', replaceUrl);
      } else if (videoUrl.includes('vimeo.com')) {
        const replaceUrl = this.convertToEmbed(videoUrl);
        iframe.attr('src', `${replaceUrl}?autoplay=1`);
      } else if (videoUrl.includes('kaltura.com')) {
        iframe.attr('src', `${videoUrl}&autoPlay=true`);
      } else if (videoUrl.endsWith('.mp4')) {
        iframe = $('<video/>');
        iframe.attr('src', videoUrl);
        iframe.attr('controls', true);
        iframe.attr('autoplay', true);
      } else {
        console.warn('Unsupported video format');
        return;
      }

      iframe.attr('frameborder', '0');
      iframe.attr('allow', 'autoplay; encrypted-media');
      iframe.attr('allowfullscreen', true);

      const container = $target.siblings(this.classes.videoContainer);
      container.addClass(this.classes.appended);
      container.append(iframe);

      $target.replaceWith(container);
    });
  }

  convertToEmbed(url) {
    const urlYoutube = 'https://www.youtube.com/embed/'
    if (url.toLowerCase().indexOf('youtube.com') !== -1 && url.toLowerCase().indexOf('youtube.com/embed') === -1) {
      const tempV = url.split('?v=')[1]
      const v = tempV.split('&')[0]
      return `${urlYoutube + v}?autoplay=1&rel=0&showinfo=0`
    }
    if (url.toLowerCase().indexOf('vimeo.com') !== -1 && url.toLowerCase().indexOf('player.vimeo.com/video') === -1) {
      const parts = url.split('/')
      const v2 = parts.pop()
      return `https://player.vimeo.com/video/${v2}?autoplay=1&muted=0`
    }
    if (url.toLowerCase().indexOf('youtu.be') !== -1) {
      const parts2 = url.split('/')
      const v3 = parts2.pop()
      return `${urlYoutube + v3}?autoplay=1&rel=0&showinfo=0`
    }

    return url
  }
}

new VideoInline().init();
